<template>
    <div>
        <a class="uk-button uk-button-default" :href="`#image-modal-${componentID}`" uk-toggle>{{multiple ? `Kies foto's` : `Kies foto`}}</a>
        <div class="uk-modal-container" :id="`image-modal-${componentID}`" uk-modal>
            <div class="uk-modal-dialog" >
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-align-left">{{multiple ? `Kies foto's` : `Kies foto`}}</h2>
                     <button class="uk-button uk-button-primary uk-align-right uk-modal-close" @click.prevent="choose">Kies</button>
                </div>
                <div class="uk-modal-body" uk-overflow-auto>
                    <div class="uk-child-width-1-6@m" uk-grid>
                        <div v-for="(m, id) in media">
                            <div class="uk-card uk-link uk-card-default">
                                <div class="uk-card-media-top">
                                    <img @click.prevent="select(id, m)" :src="m.url" alt="">
                                </div>
                                <div class="uk-card-badge uk-label" v-if="selected[id]">
                                    <span uk-icon="check"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer">
                    <button class="uk-button uk-button-primary uk-align-right uk-modal-close" @click.prevent="choose">Kies</button>
                    <button class="uk-button uk-button-danger uk-align-right uk-modal-close">Annuleren</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import {db, storage} from '@/CUSTOM/helpers/firebase'
export default {
    name:'ImagePicker',
    props: {
        'multiple':{
            default: true
        }
    },
    data () {
        return {
            media: null,
            componentID: null,
            selected: {}
        }
    },
    created () {
        this.componentID = Math.floor((Math.random() * 100) + 1)

        db.collection('media').onSnapshot((snap) => {
            this.media = {}
            snap.forEach((doc) => {
                this.media[doc.id] = doc.data()
            })
        })
    },
    methods: {
        select (id, m) {
            if(this.selected[id]) {
                Vue.delete(this.selected, id)
            } else {
                if(this.multiple) {
                    Vue.set(this.selected, id , m)
                } else {
                    this.selected = {}
                    Vue.set(this.selected, id , m)
                }
                
            }
        },
        choose () {
            this.$emit('choose', this.selected)
            this.selected = {}
        }
    }
}
</script>
<style>
    .uk-card-badge {
        top: 10px !important;
        right: 10px !important;
    }
</style>


// WEBPACK FOOTER //
// imagePicker.vue?37a6db7c